// Modules
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createReduxHistoryContext } from 'redux-first-history';
import { createBrowserHistory } from 'history';
import createSagaMiddleware from 'redux-saga';

// Reducers
import { appDataReducer, uiStateReducer } from './reducers';
import initialState from './initialState';


const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
    history: createBrowserHistory(),
});

// create the saga middleware
export const sagaMiddleware = createSagaMiddleware();
export const store = createStore(
    combineReducers({
        router: routerReducer,
        uiState: uiStateReducer,
        appData: appDataReducer,
    }),
    initialState,
    composeWithDevTools(applyMiddleware(routerMiddleware, sagaMiddleware)),
);

export const history = createReduxHistory(store);
